export default "__VITE_ASSET__DpI67OC9__"